import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const NoContent = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: 'no-content-element' */ './ui/no-content')),
});
